var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_vm._v("Show this category if "+_vm._s(_vm.parentNodeName)+" is equal to ")]),_c('v-col',[_c('v-select',{attrs:{"items":_vm.parentRecord.meta.choices},on:{"change":_vm.setConditions},model:{value:(_vm.conditionHolder),callback:function ($$v) {_vm.conditionHolder=$$v},expression:"conditionHolder"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }